import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import OtpErrorPageBlockData from 'Models/Content/OtpErrorPageBlockData';
import MainErrorPage from './MainErrorPage';

export default class OtpErrorPageBlock extends EpiComponent<OtpErrorPageBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    return <MainErrorPage iContent={this.props.data} context={this.getContext()} />;
  }
}

